import { render, staticRenderFns } from "./ViewRenameMigration.vue?vue&type=template&id=75209823&"
import script from "./ViewRenameMigration.vue?vue&type=script&lang=ts&"
export * from "./ViewRenameMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports